import React from "react";

export default function RecruiterTag({ inline = true, style = {} }) {
  return (
    <>
      {inline ? (
        <span className="recruiter-tag-inline" style={style}>
          Posted by recruiter
        </span>
      ) : (
        <div className="recruiter-tag" style={style}>
          Posted by recruiter
        </div>
      )}
    </>
  );
}
